module.exports = __webpack_public_path__ + "c8cb829a15bd247dd37f205a9497a6b1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PT.svg
// module id = Vc1j
// module chunks = 0